// extracted by mini-css-extract-plugin
module.exports = {"Content":"Layout_Content__1zph1","nopadd":"Layout_nopadd__1IE-4"};